import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs, FreeMode, Autoplay } from 'swiper/modules';


const initSlider = () => {
    let swiperInstances = [];
    const initializeSliders = () => {
        // Destroy existing swiper instances
        swiperInstances.forEach(swiper => {
            if (swiper && swiper.destroy) {
                swiper.destroy(true, true);
            }
        });
        swiperInstances = [];

        // Initialize text-image sliders
        const textImageSwipers = document.querySelectorAll('.text-image-slider-swiper');
        textImageSwipers.forEach(swiperEl => {
            // Find navigation and pagination elements within this specific slider container
            const nextButton = swiperEl.querySelector('.swiper-button-next');
            const prevButton = swiperEl.querySelector('.swiper-button-prev');
            const pagination = swiperEl.querySelector('.swiper-pagination');

            const swiper = new Swiper(swiperEl, {
                modules: [Navigation, Pagination, Autoplay],
                spaceBetween: 30,
                slidesPerView: 1,
                loop: true,
                speed: 1000,
                pagination: {
                    el: pagination,
                    clickable: true,
                },
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                }
            });
            swiperInstances.push(swiper);
        });

        // Initialize logo sliders
        const logoSwipers = document.querySelectorAll('.logo-slider-swiper');
        logoSwipers.forEach(swiperEl => {
            const swiper = new Swiper(swiperEl, {
                modules: [Autoplay],
                loop: true,
                spaceBetween: 16,
                slidesPerView: 3,
                speed: 6000,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: false,
                },
                breakpoints: {
                    576: {
                        slidesPerView: 4,
                    },
                    768: {
                        slidesPerView: 5,
                    },
                    1024: {
                        slidesPerView: 5,
                    },
                    1280: {
                        slidesPerView: 6,
                    },
                    1400: {
                        slidesPerView: 8,
                    },
                },
            });
            swiperInstances.push(swiper);
        });

        // Initialize highlight thumbnail sliders
        const highlightSliders = document.querySelectorAll('.highlight-slider');
        highlightSliders.forEach(sliderWrapper => {
            const mainSwiper = sliderWrapper.querySelector('.highlight-swiper-main');
            const thumbSwiper = sliderWrapper.querySelector('.highlight-swiper-thumbs');

            // Check if we're on mobile (screen width < 768px)
            const isMobile = window.innerWidth < 768;

            if (isMobile) {
                // Mobile: Only initialize main slider with navigation, no thumbnails
                const mainSliderobject = new Swiper(mainSwiper, {
                    modules: [Navigation, Pagination, Autoplay],
                    spaceBetween: 10,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    navigation: {
                        nextEl: mainSwiper.querySelector('.swiper-button-next'),
                        prevEl: mainSwiper.querySelector('.swiper-button-prev'),
                    },
                });
                swiperInstances.push(mainSliderobject);
            } else {
                // Desktop: Initialize both main and thumbnail sliders
                if (thumbSwiper) {
                    
                    const thumbSliderobject = new Swiper(thumbSwiper, {
                        modules: [FreeMode, Thumbs, Navigation, Pagination],
                        spaceBetween: 10,
                        slidesPerView: 7,
                        watchSlidesProgress: true,
                        watchSlidesVisibility: true,

                    });
                    
                    const mainSliderobject = new Swiper(mainSwiper, {
                        modules: [Navigation, Pagination, Thumbs, Autoplay],
                        spaceBetween: 10,
                        autoplay: {
                            delay: 5000,
                            disableOnInteraction: false,
                        },
                        navigation: {
                            nextEl: mainSwiper.querySelector('.swiper-button-next'),
                            prevEl: mainSwiper.querySelector('.swiper-button-prev'),
                        },
                        thumbs: {
                            swiper: thumbSliderobject,
                        },
                    });
                    swiperInstances.push(mainSliderobject, thumbSliderobject);
                }
            }
        });

        // Initialize benefits slider
        const benefitsSwipers = document.querySelectorAll('.benefits-slider-swiper');
        benefitsSwipers.forEach(swiperEl => {
            const swiper = new Swiper(swiperEl, {
                modules: [Navigation, Pagination, Autoplay],
                spaceBetween: 15,
                slidesPerView: 1.5,
                speed: 1000,
                centeredSlides: true,
                breakpoints: {
                    576: {
                        spaceBetween: 20,
                        slidesPerView: 2,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                    1024: {
                        spaceBetween: 30,
                        slidesPerView: 3.5,
                    },
                    1280: {
                        slidesPerView: 4,
                    },
                },
                pagination: {
                    el: swiperEl.querySelector('.swiper-pagination'),
                },
                navigation: {
                    nextEl: swiperEl.querySelector('.swiper-button-next'),
                    prevEl: swiperEl.querySelector('.swiper-button-prev'),
                },
            });
            swiperInstances.push(swiper);
        });

        // Initialize job details slider
        const jobDetailsSwipers = document.querySelectorAll('.job-details-slider-swiper');
        jobDetailsSwipers.forEach(swiperEl => {
            const swiper = new Swiper(swiperEl, {
                modules: [Navigation, Pagination, Autoplay],
                spaceBetween: 10,
                slidesPerView: 1,
                loop: true,
                speed: 1000,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: swiperEl.querySelector('.swiper-pagination'),
                    clickable: true,
                },
                navigation: {
                    nextEl: swiperEl.querySelector('.swiper-button-next'),
                    prevEl: swiperEl.querySelector('.swiper-button-prev'),
                },
            });
            swiperInstances.push(swiper);
        });
    };

    // Initialize sliders on load
    initializeSliders();

    // Reinitialize sliders on window resize
    window.addEventListener('resize', () => {
        initializeSliders();
    });
};

export default initSlider;